import tw from "twin.macro"

export const Wrapper = tw.div`
  mt-2-4 md:mt-3 mb-4 md:mb-3
`
